<template>
  <b-media
    class="notification-card "
    :class="(!notification.isRead && unReadNotifications!=0) && 'notification-card--active'"
  >
    <template #aside>
      <b-avatar
        size="42"
        :variant="displayNotification.type"
      >
        <feather-icon
          :icon="displayNotification.icon"
        />
      </b-avatar>
    </template>
    <p class="media-heading d-flex align-items-center mb-0">
      <span class="font-weight-bolder">
        {{ displayNotification.title }}
      </span>
      <feather-icon
        v-if="!notification.isRead && unReadNotifications!=0"
        icon="CircleIcon"
        size="8"
        fill="#3D61AD"
        class="ml-1 text-primary"
      />
    </p>
    <small class="notification-text">{{ displayNotification.subtitle }}</small>
    <div class="text-right">
      <small class="text-mute">
        {{ fromNow(UTCtoLocal(displayNotification.createdAt)) }}
      </small>
    </div>
  </b-media>
</template>
<script>
import { BMedia, BAvatar } from 'bootstrap-vue'

export default {
  components: {
    BMedia,
    BAvatar,
  },
  props: {
    notification: {
      type: [Array, Object],
      default: () => {},
    },
    unReadNotifications: {
      type: [Number, String],
      default: 0,
    },
  },
  computed: {
    displayNotification() {
      const currentUser = JSON.parse(localStorage.getItem('userData'))
      const {
        notification, isRead, uuid, createdAt,
      } = this.notification
      const {
        user, project, permission, permissionAction,
      } = notification

      const allowed = permissionAction === 'ALLOW'

      // eslint-disable-next-line no-nested-ternary
      const displayUser = user.uuid === currentUser.uuid
        ? allowed ? 'You have been allowed to' : 'You can no longer'
        : allowed ? `${user.name} has been allowed to` : `${user.name} can no longer`

      const title = 'Permission Updated!'
      const subtitle = `${displayUser} ${permission.description.toLowerCase()} in the project - ${project.name}`
      const type = allowed ? 'light-success' : 'light-danger'
      const icon = allowed ? 'UserCheckIcon' : 'UserXIcon'

      return {
        title, subtitle, type, icon, isRead, uuid, createdAt,
      }
    },
  },
}
</script>
